var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M17.1681047,19.2837668 C17.1681047,19.2837668 3.22538413,23.0140185 0.57058039,36.213737 C0.57058039,36.213737 7.98726568,39.3400613 17.8158502,34.7077288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M62.1681047,19.2837668 C62.1681047,19.2837668 48.2253841,23.0140185 45.5705804,36.213737 C45.5705804,36.213737 52.9872657,39.3400613 62.8158502,34.7077288",
    transform: "matrix(-1 0 0 1 108.386 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 36,
    fill: "#D8D8D8",
    rx: 21,
    ry: 27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 15,
    r: 5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 15,
    r: 5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 18,
    r: 5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 15,
    r: 5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 9,
    r: 5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 9,
    r: 5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 15,
    r: 5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 9,
    r: 5,
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M34.9319805,55.9926407 C36.03655,55.9926407 38.3461941,53.0114237 38.3461941,51.0784271 C38.3461941,49.1454305 36.7436568,48.2855339 35.6390873,48.2855339 C34.5345178,48.2855339 32.9319805,50.5596441 32.9319805,52.4926407 C32.9319805,54.4256373 33.827411,55.9926407 34.9319805,55.9926407 Z",
    transform: "rotate(45 35.64 52.14)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M27.4319805,55.9926407 C28.53655,55.9926407 30.8461941,53.0114237 30.8461941,51.0784271 C30.8461941,49.1454305 29.2436568,48.2855339 28.1390873,48.2855339 C27.0345178,48.2855339 25.4319805,50.5596441 25.4319805,52.4926407 C25.4319805,54.4256373 26.327411,55.9926407 27.4319805,55.9926407 Z",
    transform: "scale(-1 1) rotate(45 0 -15.795)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 32,
    r: 4,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 32,
    r: 2,
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 32,
    r: 4,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 32,
    r: 2,
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamb);
export default __webpack_public_path__ + "static/media/lamb.4e5a7fb6baa03ef4c9ebb2afdacc0234.svg";
export { ForwardRef as ReactComponent };